// extracted by mini-css-extract-plugin
module.exports = {"drawerPopup":"style_drawerPopup__Ua1ae","closeIconWrapper":"style_closeIconWrapper__zdV4j"};